<div class="content" #content [style.-webkit-line-clamp]="isExpanded ? 'unset' : lineClamp">
  <ng-content></ng-content>
</div>

<ng-container *ngIf="isOverflowing">
  <button class="toggle-content" [class.positioned-absolute]="positionButtonsAbsolute" (click)="toggleContent()" ui-button uiShape="round" uiType="link" uiSize="small">
    <ng-container *ngIf="!isExpanded">{{ "view_more" | localize }} <i ui-icon uiType="arrow-down-small"></i></ng-container>
    <ng-container *ngIf="isExpanded">{{ "view_less" | localize }} <i ui-icon uiType="arrow-up-small"></i></ng-container>
  </button>
</ng-container>
